import { groupSeries, searchTitles, durationToMinutes } from '@site/lib/catalog';
import { api } from '../api/client';

/**
 * Le catalogue, tel que le site le voit.
 *
 * `@site/lib/catalog` est le module du site, importé sans être modifié : il
 * n'a aucune dépendance et ses fonctions sont pures. Regrouper les épisodes
 * par série, chercher, trier — tout ça existe déjà et se comporte exactement
 * pareil des deux côtés. Le réécrire aurait garanti deux comportements
 * divergents dès le premier changement.
 */

/**
 * Le catalogue complet, films et séries regroupées, prêt à afficher.
 *
 * `groupSeries` rend **déjà** les films en plus des séries regroupées : lui
 * ajouter les films filtrés à part les affichait deux fois.
 */
export async function chargerCatalogue() {
  const brut = await api.get('/movies');
  const lignes = Array.isArray(brut) ? brut : brut?.data || brut?.movies || [];

  return groupSeries(lignes).sort((a, b) =>
    String(a.title || '').localeCompare(String(b.title || ''), 'fr'),
  );
}

/** Les épisodes d'une série, dans l'ordre. */
export function episodesDe(titre) {
  return [...(titre.episodes || [])].sort(
    (a, b) => (a.season - b.season) || (a.episode - b.episode),
  );
}

/**
 * Filtre le catalogue. Sans requête, il repart entier — c'est à l'affichage de
 * décider ce qu'il rend, pas à la recherche de décider ce qui existe.
 */
export function chercher(titres, requete) {
  const propre = requete.trim();
  return propre ? searchTitles(titres, propre, titres.length) : titres;
}

export function dureeLisible(titre) {
  const minutes = durationToMinutes(titre.duration);
  if (!minutes) return null;

  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  return h > 0 ? `${h} h ${String(m).padStart(2, '0')}` : `${m} min`;
}
